__turbopack_context__.v({
  "chartColumnBesideFilters": "StateDonutChartChrome-module__W9YFnW__chartColumnBesideFilters",
  "chromeScope": "StateDonutChartChrome-module__W9YFnW__chromeScope",
  "mainRow": "StateDonutChartChrome-module__W9YFnW__mainRow",
});
